import { getStatusByLabel } from 'enums/funding-match-status';
import {
  CLOSE_CANCEL_FUNDING_SEARCH_MATCH_MODAL,
  OPEN_CANCEL_FUNDING_SEARCH_MATCH_MODAL,
  fundingMatchStatus,
  cancelFundingSearchMatch,
  SSE_UPDATE_FUNDING_MATCH_SUCCESS,
  SET_IGNORED_MATCH_STATUSES,
  SET_FETCHING_OFFER_MATCH_IDS,
  SET_FUNDING_MATCH_NOTIFICATION,
  DELETE_FETCHING_OFFER_MATCH_ID,
} from './types';

export * from './actions';

const fundingSearchMatchReducerObject = {
  [CLOSE_CANCEL_FUNDING_SEARCH_MATCH_MODAL]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['cancelFundingSearchMatch', 'modalOpen'], false)
        .setIn(['cancelFundingSearchMatch', 'match'], null),
    ),
  [OPEN_CANCEL_FUNDING_SEARCH_MATCH_MODAL]: (state, { matchInstance }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['cancelFundingSearchMatch', 'modalOpen'], true)
        .setIn(['cancelFundingSearchMatch', 'match'], matchInstance),
    ),
  [cancelFundingSearchMatch.request]: (state) =>
    state.setIn(['cancelFundingSearchMatch', 'network', 'loading'], true),
  [cancelFundingSearchMatch.success]: (state, { payload, response }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['cancelFundingSearchMatch', 'network', 'loading'], false)
        .setIn(['cancelFundingSearchMatch', 'network', 'error'], null)
        .updateIn(['byId', payload.fundingSearchId, 'matches'], (matches) =>
          matches.reduce(
            (previous, match) => [...previous, match.id !== response.id ? match : response],
            [],
          ),
        ),
    ),
  [cancelFundingSearchMatch.error]: (state, error) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['cancelFundingSearchMatch', 'network', 'loading'], false)
        .setIn(['cancelFundingSearchMatch', 'network', 'error'], error),
    ),

  [SSE_UPDATE_FUNDING_MATCH_SUCCESS]: (state, { response, sseUpdateData }) =>
    state.withMutations((currentState) =>
      currentState.updateIn(['byId', sseUpdateData.fundingSearchId, 'matches'], (matches) =>
        matches.reduce(
          (previous, match) => [
            ...previous,
            match.id !== sseUpdateData.fundingMatchId ? match : response,
          ],
          [],
        ),
      ),
    ),

  [SET_IGNORED_MATCH_STATUSES]: (state, { matchId, statuses }) =>
    state.withMutations((s) => s.setIn(['matchIgnoredStatuses', matchId], statuses)),

  [SET_FETCHING_OFFER_MATCH_IDS]: (state, action) =>
    state.withMutations((currentState) =>
      currentState.update('fetchingOfferMatchIds', (list) => list.push(action.matchId)),
    ),

  [SET_FUNDING_MATCH_NOTIFICATION]: (state, { matchId, notification }) =>
    state.withMutations((currentState) =>
      currentState.update('notifications', (list) => {
        if (!notification) {
          return list.filter((item) => item.matchId !== matchId);
        }

        return [...list, { matchId, notification }];
      }),
    ),

  [DELETE_FETCHING_OFFER_MATCH_ID]: (state, action) =>
    state.withMutations((currentState) =>
      currentState.update('fetchingOfferMatchIds', (list) =>
        list.filter((matchId) => matchId !== action.matchId),
      ),
    ),

  [fundingMatchStatus.success]: (state, { payload, response }) =>
    state.withMutations((currentState) =>
      currentState.updateIn(['byId', payload.fundingSearchId, 'matches'], (matches = []) =>
        matches.map((match) => {
          if (match.id === payload.fundingMatchId) {
            const newMatch = { ...match };
            newMatch.status = getStatusByLabel(response.status);
            return newMatch;
          }
          return match;
        }),
      ),
    ),
};

export default fundingSearchMatchReducerObject;
